import React from "react";
import { Layout } from "antd";
import { Link } from 'react-router-dom';
// import { FaInstagram } from 'react-icons/fa';


const { Footer } = Layout;
// const Icon = FaInstagram as React.FC;


const AppFooter: React.FC = () => {
  return (
    <Footer className="app-footer">
      <div className="footer-content" style={{ textAlign: 'center' }}>
        <div className="footer-text">
          <strong>ChowMeDown</strong> &copy; {new Date().getFullYear()} &mdash; All rights reserved.
        </div>
        <div className="footer-disclaimer">
          Disclaimer: ChowMeDown provides general nutritional guidance and does not replace professional veterinary advice. Always consult your veterinarian before making changes to your dog's diet.
        </div>
        <hr className="footer-divider" />
        <div className="footer-text">
          <Link to="/privacy" className="link-text">Privacy Policy</Link>
          <span style={{ margin: '0 0.7rem' }}>•</span>
          <Link to="/terms" className="link-text">Terms of Service</Link>
          <span style={{ margin: '0 0.7rem' }}>•</span>
          <a href="mailto:chowmedown321@gmail.com" className="link-text">Contact</a>
          <span style={{ margin: '0 0.7rem' }}>•</span>
          <a href="https://instagram.com/chowmedown_" target="_blank" rel="noopener noreferrer" className="link-text">Instagram</a>
        </div>
      </div>
    </Footer>
  );
};

export default AppFooter;